//iniitalize the tracking technology
function initializeTracking()
{
	if(!isTrackingEnabled()){return false;}
	(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
		(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
		m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
		})(window,document,'script','//www.google-analytics.com/analytics.js','_ga');
	if(oiConfig.gCookiePath)
	{ 
		for (var i=0; i<oiConfig.gTrackingIds.length; i++) {
			_ga('create', {
				trackingId: oiConfig.gTrackingIds[i],
				cookieDomain: gCookiePath,
				name: 'gaTracker'+i
			});
		}
	}  else {
		for (var i=0; i<oiConfig.gTrackingIds.length; i++) {
			_ga('create', {
				trackingId: oiConfig.gTrackingIds[i],
				name: 'gaTracker'+i
			});
		}
	}
}

//call the google analytics tracking site
//the assumption is that all the tracking and variable stuff has been loaded
function finalizeTracking(viewId)
{
	if(!isTrackingEnabled()){return false;}
	for (var i=0; i<oiConfig.gTrackingIds.length; i++) {
		_ga('gaTracker'+i+'.set', 'page',viewId);
		_ga('gaTracker'+i+'.send', 'pageview');
	}
}

/**
 * track multiple variables
 * @param variables
 * @return
 */
function trackVariables(variables)
{
	//if tracking not enabled then continue
	if(!isTrackingEnabled()){return false;}	
    try
    {
    	for (var i=0; i<oiConfig.gTrackingIds.length; i++) {
    		_ga('gaTracker'+i+'.send', 'pageview',variables);
    	}
    }
    catch(err){doDebug(err.message);}
}

function setVariables(variables)
{
	//if tracking not enabled then continue
	if(!isTrackingEnabled()){return false;}	
    try
    {
		for (var i=0; i<oiConfig.gTrackingIds.length; i++) {
    		_ga('gaTracker'+i+'.set',variables);
		}
    }
    catch(err){doDebug(err.message);}
}

//wrapper for tracking events. Dele_gates the call to the _gaTC
function trackEvent(category,action,label,value)
{
	//if tracking not enabled then continue
	if(!isTrackingEnabled()){return false;}
    try
    {
        doDebug("category: " + category + " \naction: " + action + " \nlabel: " + label + " \nvalue:" + value);
		for (var i=0; i<oiConfig.gTrackingIds.length; i++) {
			if(label && value) {
				_ga('gaTracker'+i+'.send', 'event', category, action, label, value);
			} else if(label) {
				_ga('gaTracker'+i+'.send', 'event', category, action, label);
			} else {
				_ga('gaTracker'+i+'.send', 'event', category, action);
			}
		}
    }catch(err) {doDebug(err.message);}
}

function trackTransaction(orderId,total,storeName,state,tax,shipping,city,cartItems,url)
{
	//if tracking not enabled then continue
	if(!isTrackingEnabled()){return false;}
	try{
		for (var i=0; i<oiConfig.gTrackingIds.length; i++) {
			_ga('gaTracker'+i+'.require', 'ec');
			_ga('gaTracker'+i+'.ec:setAction', 'purchase',{
				'id':orderId, // order ID - required
				'affiliation':storeName, // affiliation or store name
				'revenue':total, // total
				'tax':tax, // tax
				'shipping':shipping // shipping
			});
			_.each(cartItems,function(s)
			{
				doDebug(s);
				_ga('gaTracker'+i+'.ec:addProduct', {
					'id': s[0], // SKU/code - required
					'name': s[1], // product name - required
					'category': s[2], // category or variation
					'price': s[3], // unit price
					'quantity': s[4]// quantity
				});
			});
			_ga('gaTracker'+i+'.send', 'pageview');
		}
	} catch(err) {
		doDebug("trackTransaction.."+err.message);
	}
}

//function to track the page 
function trackPage(pageId)
{
	//if tracking not enabled then continue
	if(!isTrackingEnabled()){return false;}
    try
    {
    	doDebug("pageId:" +pageId);
		for (var i=0; i<oiConfig.gTrackingIds.length; i++) {
			if (pageId) {
				_ga('gaTracker'+i+'.send', 'pageview', pageId);
			} else {
				_ga('gaTracker'+i+'.send', 'pageview');
			}
		}
    }
    catch(err)
    {doDebug("trackPage.."+err.message);}
}

function isTrackingEnabled()
{
	var tEnabled = false;
	//if tracking not enabled then continue
	try{
	if((oiConfig)  && (oiConfig.gTrackingIds != ""))
	{
		tEnabled = oiConfig.gTrackingEnabled;
	}     
	}catch(err){}
	
    return tEnabled;
}